import { memo } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

import DashboardMetricCard from './DashboardMetricCard';
import { getDashboardMetricIcon } from '../helpers/dashboardPresentation';
import type { EDashboardSegmentKey, TDashboardMetric } from '../types/dashboard.types';

const useStyles = makeStyles({
  metricGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(184px, 1fr))',
    gap: tokens.spacingHorizontalM,
  },
});

type TProps = {
  metrics: TDashboardMetric[];
  controlsId?: string;
  selectedSegmentKey?: EDashboardSegmentKey;
  onSelectedSegmentKeyChange?: (segmentKey: EDashboardSegmentKey) => void;
};

const DashboardMetricGrid = ({ metrics, controlsId, selectedSegmentKey, onSelectedSegmentKeyChange }: TProps) => {
  const classes = useStyles();

  return (
    <div className={classes.metricGrid} aria-label="Dashboard item counters">
      {metrics.map((metric) => (
        <DashboardMetricCard
          key={metric.segmentKey}
          metric={metric}
          icon={getDashboardMetricIcon(metric)}
          controlsId={controlsId}
          isSelected={selectedSegmentKey === metric.segmentKey}
          onClick={onSelectedSegmentKeyChange ? () => onSelectedSegmentKeyChange(metric.segmentKey) : undefined}
        />
      ))}
    </div>
  );
};

export default memo(DashboardMetricGrid);
